import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const EDIT_ALERTS_MESSAGING = gql`
  mutation ($messages: [EUMessageInput]) {
    EditEUMessages(messages: $messages)
  }
`;

export function useEUMessagesMutations () {

  const [edit] = useMutation(EDIT_ALERTS_MESSAGING,
    { refetchQueries: ['getEUMessage'] },
  );

  return {edit};
}
